"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface StatData {
  value: number;
  prefix: string;
  suffix: string;
  label: string;
}
const stats: StatData[] = [{
  value: 40,
  prefix: "",
  suffix: "+",
  label: "Years of Expertise"
}, {
  value: 500,
  prefix: "",
  suffix: "+",
  label: "Global Transformations"
}, {
  value: 2,
  prefix: "$",
  suffix: "B+",
  label: "Value Created"
}];
function AnimatedNumber({
  value,
  prefix,
  suffix,
  isVisible
}: {
  value: number;
  prefix: string;
  suffix: string;
  isVisible: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number | null = null;
    const duration = 2500;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 5);
      setCount(Math.floor(easeProgress * value));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(value);
      }
    };
    requestAnimationFrame(animate);
  }, [value, isVisible]);
  return <span className="font-mono text-6xl sm:text-7xl md:text-8xl font-extrabold tracking-tighter text-primary drop-shadow-[0_0_20px_rgba(var(--color-primary),0.25)]">
      {prefix}
      {count}
      {suffix}
    </span>;
}
export default function TheFirmsImpact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3,
    once: true
  });
  return;
}